import ApiService from '@/common/api.service'

export default {
  state: {
    programs: [],
    programTypes: [],
    programDurationUnits: [],
    subjectTypes: [],
    lang: localStorage.getItem('language') || 'ar',
  },
  getters: {
    programs(state) {
      return state.programs
    },
    programsOptions(state) {
      return state.programs
        .filter(p => p.is_active)
        .map(program => ({
          id: program.id,
          title: program.title[state.lang],
          type: program.type,
        }))
    },
    programsByEntityId(state) {
      return entity_id =>
        state.programs
          .filter(program => program.entity_id === entity_id)
          .map(program => ({ id: program.id, title: program.title[state.lang] }))
    },
    programTypes(state) {
      return state.programTypes
    },
    programDurationUnits(state) {
      return state.programDurationUnits
    },
    subjectTypes(state) {
      return state.subjectTypes
    },
  },
  mutations: {
    setPrograms(state, programs) {
      state.programs = programs
    },
    setProgramTypes(state, data) {
      return (state.programTypes = data.map(item => ({ id: item.id, title: item.title[state.lang] })))
    },
    setProgramDurationUnits(state, data) {
      return (state.programDurationUnits = data.map(item => ({ id: item.id, title: item.title[state.lang] })))
    },
    setSubjectTypes(state, data) {
      return (state.subjectTypes = data.map(item => ({ id: item.id, title: item.title[state.lang] })))
    },
  },
  actions: {
    async getPrograms({ state, commit }, payload) {
      if (state.programs.length && !payload?.force) return
      const { data } = await ApiService.query('programs', { ...payload })
      return commit('setPrograms', data)
    },
    async getProgramTypes({ state, commit }) {
      if (state.programTypes.length) return
      const { data } = await ApiService.query('program-types', { lang: state.lang })
      return commit('setProgramTypes', data)
    },
    async getProgramDurationUnits({ state, commit }) {
      if (state.programDurationUnits.length) return
      const { data } = await ApiService.query('program-duration-units', { lang: state.lang })
      return commit('setProgramDurationUnits', data)
    },
    async getSubjectTypes({ state, commit }) {
      if (state.subjectTypes.length) return
      const { data } = await ApiService.query('subject-types', { lang: state.lang })
      return commit('setSubjectTypes', data)
    },
  },
}
